module.exports = __webpack_public_path__ + "static/media/pp_colored_gaint_straw3.efd4308c.png";